<template>
  <section class="mc-rec-section">
    <h2 class="mc-rec-section__title">Desempenho do período</h2>
    <p class="mc-rec-section__desc">
      Período selecionado: <strong style="color: #221c35;">{{ periodoLabel }}</strong>
    </p>

    <div v-if="loading" class="text-center py-5">
      <b-spinner style="color: #5b028c;" />
    </div>
    <template v-else-if="dados">
      <b-row class="mb-3">
        <b-col md="4" lg="2" class="mb-2" v-for="m in kpisPrincipais" :key="m.key">
          <div class="mc-rec-metric h-100">
            <div class="mc-rec-metric__label d-flex align-items-center flex-wrap">
              <span>{{ m.label }}</span>
              <span
                v-if="m.key === 'ctr'"
                v-b-tooltip.hover.top="'CTR (taxa de cliques): percentual de cliques sobre as mensagens lidas no período. Fórmula: (número de cliques ÷ número de lidos) × 100.'"
                tabindex="0"
                class="mc-rec-help-q ml-25"
              >?</span>
            </div>
            <div class="mc-rec-metric__value">{{ m.valor }}</div>
            <div v-if="comparar && m.delta != null" class="mc-rec-delta" :class="m.delta >= 0 ? 'mc-rec-delta--up' : 'mc-rec-delta--down'">
              {{ m.delta >= 0 ? '↑' : '↓' }} {{ formatarDelta(m.delta) }}
            </div>
          </div>
        </b-col>
      </b-row>
      <div class="mc-rec-surface p-3">
        <b-row>
          <b-col sm="6" md="4" lg="2" class="mb-2 mb-lg-0" v-for="s in secundarias" :key="s.label">
            <div class="small text-muted text-uppercase" style="font-size: 0.65rem; letter-spacing: 0.04em;">{{ s.label }}</div>
            <div class="font-weight-bold" style="color: #221c35;">{{ s.valor }}</div>
          </b-col>
        </b-row>
      </div>
    </template>
  </section>
</template>

<script>
import { BRow, BCol, BSpinner } from 'bootstrap-vue'

export default {
  name: 'RecommendationPeriodSummary',
  components: { BRow, BCol, BSpinner },
  props: {
    loading: Boolean,
    periodoLabel: { type: String, default: '' },
    comparar: Boolean,
    dados: { type: Object, default: null },
    dadosAnterior: { type: Object, default: null },
  },
  computed: {
    kpisPrincipais() {
      const d = this.dados
      if (!d) return []
      const a = this.dadosAnterior
      const pct = (atual, ant) => {
        if (!this.comparar || ant == null || Number(ant) === 0) return null
        return ((Number(atual) - Number(ant)) / Number(ant)) * 100
      }
      return [
        {
          key: 'rec',
          label: 'Receita do período',
          valor: `R$ ${this.fmtM(d.receita)}`,
          delta: pct(d.receita, a?.receita),
        },
        {
          key: 'ped',
          label: 'Pedidos gerados',
          valor: String(d.pedidos ?? 0),
          delta: pct(d.pedidos, a?.pedidos),
        },
        {
          key: 'roi',
          label: 'ROI do período',
          valor: d.roiTexto,
          delta: pct(d.roiNum, a?.roiNum),
        },
        {
          key: 'conv',
          label: 'Conversão',
          valor: d.conversao,
          delta: pct(d.convNum, a?.convNum),
        },
        {
          key: 'ctr',
          label: 'CTR do período',
          valor: d.ctr,
          delta: pct(d.ctrNum, a?.ctrNum),
        },
        {
          key: 'cac',
          label: 'CAC',
          valor: `R$ ${this.fmtM(d.cac)}`,
          delta: pct(d.cac, a?.cac) != null ? -pct(d.cac, a?.cac) : null,
        },
      ]
    },
    secundarias() {
      const d = this.dados
      if (!d) return []
      return [
        { label: 'Custo total', valor: `R$ ${this.fmtM(d.custo)}` },
        { label: 'Clientes impactados', valor: String(d.clientesImpactados ?? '—') },
        { label: 'Clientes convertidos', valor: String(d.clientesConvertidos ?? '—') },
        { label: 'Ticket médio', valor: `R$ ${this.fmtM(d.ticket)}` },
      ]
    },
  },
  methods: {
    fmtM(val) {
      if (val == null || val === '') return '0,00'
      const n = parseFloat(val)
      return Number.isNaN(n) ? '0,00' : n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatarDelta(n) {
      if (n == null) return ''
      const s = n >= 0 ? '+' : ''
      return `${s}${n.toFixed(1)}%`
    },
  },
}
</script>
